import JSEncrypt from 'jsencrypt';
import { getPublicKeyPem, setPublicKeyPem } from './session';
import { PUBLIC_KEY_B64, toPemFromB64 } from '../constants/security';

// Ensure the public key is in sessionStorage; return the PEM.
export function ensureLoginPublicKey() {
  let pem = getPublicKeyPem();
  if (!pem) {
    pem = toPemFromB64(PUBLIC_KEY_B64);
    setPublicKeyPem(pem);
  }
  return pem;
}

// Encrypt a short string (username/password) with RSA public key.


export async function encryptForLogin(plainText) {
    
  const pemPublicKey = ensureLoginPublicKey();
  if (!pemPublicKey) {
    throw new Error('Public key not available for encryption.');
  }

  // Convert PEM → binary DER
  const pemBody = pemPublicKey
    .replace('-----BEGIN PUBLIC KEY-----', '')
    .replace('-----END PUBLIC KEY-----', '')
    .replace(/\s+/g, '');
  const binaryDer = Uint8Array.from(atob(pemBody), c => c.charCodeAt(0));

  // Import OAEP key
  const publicKey = await crypto.subtle.importKey(
    'spki',
    binaryDer.buffer,
    { name: 'RSA-OAEP', hash: 'SHA-256' },
    false,
    ['encrypt']
  );

  const encoded = new TextEncoder().encode(plainText);
  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    publicKey,
    encoded
  );

  const encryptedBytes = new Uint8Array(encryptedBuffer);
  return btoa(String.fromCharCode(...encryptedBytes));
}
